import React, { useState, useEffect } from 'react';
import AdministrationDashboard from './AdministrationDashboard';
import { API_URL } from './config';
import 'bootstrap/dist/css/bootstrap.min.css';

const OveralSales = () => {
  const [sales, setSales] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [dailySalesSum, setDailySalesSum] = useState(0);
  const [overallCommission, setOverallCommission] = useState(0);

  useEffect(() => {
    const fetchSales = async () => {
      try {
        const response = await fetch(`${API_URL}/salepostrans/get_all_sales`);
        const data = await response.json();

        setSales(data);

        const today = new Date().toLocaleDateString();
        let dailySum = 0;
        let commissionSum = 0;

        data.forEach(item => {
          if (new Date(item.daterec).toLocaleDateString() === today) {
            dailySum += item.amntrec_credit > 0 ? item.amntrec_credit : item.amntrec;
          }
          commissionSum += item.commission || 0;
        });

        setDailySalesSum(dailySum);
        setOverallCommission(commissionSum);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching sales:', error);
        setIsLoading(false);
      }
    };

    fetchSales();
  }, []);

  const themeColor = '#B03F82';

  return (
    <AdministrationDashboard>
      <div className="container py-5">
        <h2 className="text-center fw-bold mb-5" >Overall Sales [Virtual Stores]</h2>

        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
            <div className="spinner-border" style={{ color: themeColor }} role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <div className="row mb-5">
              <div className="col-md-6 mb-3">
                <div className="card shadow-sm border-0 rounded-4 text-center">
                  <div className="card-body">
                    <h6 className="fw-semibold text-muted">Today's Overall Sales</h6>
                    <h3 className="fw-bold" style={{ color: themeColor }}>${dailySalesSum.toFixed(2)}</h3>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-6 mb-3">
                <div className="card shadow-sm border-0 rounded-4 text-center">
                  <div className="card-body">
                    <h6 className="fw-semibold text-muted">Overall Commission</h6>
                    <h3 className="fw-bold" style={{ color: themeColor }}>${overallCommission.toFixed(2)}</h3>
                  </div>
                </div>
              </div> */}
            </div>

            <div className="table-responsive shadow-sm rounded-4 bg-white p-4">
              <table className="table table-hover align-middle">
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                  <tr style={{ borderBottom: `2px solid ${themeColor}` }}>
                    <th>#</th>
                    <th>Company</th>
                    <th>Branch</th>
                    <th>Branch Type</th>
                    <th>Product</th>
                    <th>Decsription</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Amount</th>
                    <th>Payment Mode</th>
                    <th>User</th>
                  </tr>
                </thead>
                <tbody>
                  {sales.map((item, index) => (
                    <tr key={index} className="align-middle">
                      <td>{item.list_item_id}</td>
                      <td>{item.company_name}</td>
                      <td>{item.branch_name}</td>
                      <td>{item.branch_type}</td>
                      <td>{item.product_name}</td>
                      <td>{item.description}</td>
                      <td>{new Date(item.daterec).toLocaleDateString()}</td>
                      <td>{item.timerec}</td>
                      <td style={{ color: themeColor }}>
                        {item.amntrec_credit > 0
                          ? `$${item.amntrec_credit}`
                          : `$${item.amntrec}`}
                      </td>
                      <td>{item.pmode}</td>
                      <td>{item.username}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </AdministrationDashboard>
  );
};

export default OveralSales;
